import { createContext, useContext } from 'react';

interface GraphEntitiesContextValue {
  /** Map of lowercase entity label → Cytoscape node ID */
  graphNodeLabels: Map<string, string>;
  /** Highlight a node in the graph panel (null to clear) */
  highlightNode: (nodeId: string | null) => void;
  /** Center graph on node + open its detail popover */
  centerOnNode: (nodeId: string) => void;
  /** Label currently highlighted from graph hover (null when nothing hovered) */
  highlightedEntityLabel: string | null;
}

export const GraphEntitiesContext = createContext<GraphEntitiesContextValue>({
  graphNodeLabels: new Map(),
  highlightNode: () => {},
  centerOnNode: () => {},
  highlightedEntityLabel: null,
});

export function useGraphEntities() {
  return useContext(GraphEntitiesContext);
}
